<template>
    <div class="noticeDetailContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/notice/notice' }">更多公告</el-breadcrumb-item>
                <el-breadcrumb-item>公告详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="noticeBox">
            <div class="noticeTopBox">
                <div class="noticeTopTitle">{{ noticeDetail.title }}</div>
                <div class="noticeTopTime">{{ noticeDetail.create_time }}</div>
            </div>
            <div class="noticeDetail">
                <div v-html="noticeDetail.detail"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                noticeDetail: {}
            }
        },
        mounted(){
            this.getNoticeDetail()
        },
        methods: {
            // 获取公告详情
            getNoticeDetail(){
                this.request.get("index/index/noticedetail",{
                    params:{
                        id: this.$route.query.id
                    }
                })
                .then(res=>{
                    this.noticeDetail = res.data
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .noticeDetailContent{
        background: #FAFBFC;
        padding-bottom: 50px;
        .noticeBox{
            width: 972px;
            padding: 0 221px 50px 35px;
            background: #FFFFFF;
            border-radius: 10px;
            margin: 0 auto;
            .noticeTopBox{
                padding: 26px 0 16px 0;
                border-bottom: 1px solid #E6E7EB;
                .noticeTopTitle{
                    font: 26px/26px "Microsoft YaHei";
                    color: #464646;
                }
                .noticeTopTime{
                    font: 14px/14px "Microsoft YaHei";
                    color: #9EA1AE;
                    padding-top: 17px;
                }
            }
            .noticeDetail{
                padding: 30px 0;
            }
        }
    }
</style>